<!--
 * @Descripttion:vue-javascript-editor
 * @Author: zenghua.wang
 * @Date: 2021-09-23 09:20:10
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2022-03-03 09:43:06
-->
<template>
  <div class="editor-container" :style="styleContainer">
    <div class="editor-wrapper" ref="wrapper" :style="stylePlaceholder">
      <textarea ref="editor" v-model="code"></textarea>
    </div>
    <div class="editor-btns">
      <el-button @click="onCancel" v-if="showBtns">取 消</el-button>
      <el-button type="primary" @click="onSubmit" v-if="showBtns">确 定</el-button>
    </div>
  </div>
</template>

<script>
import CodeMirror from 'codemirror/lib/codemirror'
import 'codemirror/lib/codemirror.css'
import 'codemirror/theme/material.css'
import 'codemirror/mode/javascript/javascript.js'
import { isEmpty, fixChromeZoom } from '@/dragComponents/utils'

export default {
  props: {
    theme: {
      type: String,
      default: 'material'
    },
    value: [String, Number, Object, Array],
    placeholder: {
      type: String
    },
    readOnly: {
      type: [Boolean, String]
    },
    height: {
      type: Number,
      default: 600
    },
    showTips: {
      type: Boolean,
      default: false
    },
    showNumbers: {
      type: Boolean,
      default: true
    },
    showBtns: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      editor: null,
      code: this.value
    }
  },
  computed: {
    styleContainer() {
      return {
        width: '100%',
        height: `${this.height}px`
      }
    },
    stylePlaceholder() {
      return Object.assign(
        (() => {
          if (this.showTips) {
            return {
              borderLeft: 0,
              opacity: 0.9
            }
          }
          return {}
        })(),
        {}
      )
    }
  },
  methods: {
    onSubmit() {
      this.$emit('js-save', this.code)
    },
    onCancel() {
      this.$emit('js-cancel', false)
    }
  },
  mounted() {
    let self = this
    fixChromeZoom(this.$refs.wrapper)
    this.editor = CodeMirror.fromTextArea(this.$refs.editor, {
      // 指定语言类型,如果需要编辑和显示其他语言,需要import语言js然后修改此配置
      mode: 'text/javascript',
      // 指定主题，对应主题库JS需要提前引入
      theme: this.theme,
      // 是否智能缩进
      smartIndent: true,
      // 缩进格式
      tabSize: 2,
      // 代码折叠
      lineWrapping: true,
      // 是否显示行号
      lineNumbers: this.showNumbers,
      // line: true,
      // 高亮选中行
      styleActiveLine: true,
      // 括号匹配
      matchBrackets: true,
      // 是否为只读,如果为"nocursor" 不仅仅为只读 连光标都无法在区域聚焦
      readOnly: this.readOnly,
      // 当匹配只有一项的时候是否自动补全
      hintOptions: {
        completeSingle: true
      }
    })

    this.editor.on('change', () => {
      self.code = self.editor.getValue()
    })

    let code = !isEmpty(this.value) ? this.value : this.placeholder
    code && this.editor.setValue(code)
  }
}
</script>
<style scoped lang="scss">
.editor {
  &-container {
    height: 100%;
    display: flex;
    flex-direction: column;
    flex: 1;
    box-sizing: border-box;
  }

  &-wrapper {
    flex: 1;
    display: flex;
    flex-direction: column;
    border: 1px solid #ddd;
    overflow-y: auto;
    overflow-x: hidden;

    :deep(.CodeMirror) {
      height: 100%;
    }
  }

  &-textarea {
    width: 100%;
    height: 100%;
  }

  &-btns {
    padding-top: 10px;
    height: 40px;
  }
}
</style>
